import { render, staticRenderFns } from "./OfficeSuiteSwitcher.vue?vue&type=template&id=73a1d180&scoped=true"
import script from "./OfficeSuiteSwitcher.vue?vue&type=script&lang=js"
export * from "./OfficeSuiteSwitcher.vue?vue&type=script&lang=js"
import style0 from "./OfficeSuiteSwitcher.vue?vue&type=style&index=0&id=73a1d180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1d180",
  null
  
)

export default component.exports